import {CallHistoryMethodAction, push} from 'connected-react-router';
import {LocationState, Path} from 'history';

const pathsMap = {
  about: () => '/sobre-nos',
  auth: () => '/entrar',
  changePassword: () => '/alterar-senha',
  election: (electionId: string) => `/eleicao/${electionId}`,
  help: () => '/ajuda',
  home: () => '/inicio',
  logout: () => '/sair',
  notFound: () => '/404',
  unavailable: () => '/eleicao-indisponivel',
  setLocalePt: () => '/pt',
  setLocaleEs: () => '/es',
  setLocaleEn: () => '/en',
  resultVotes: () => `/resultado-votacao`,
  singleResultVotes: () => `/resultado-votacao-cedula-unica`,
  consultarComprovante: () => `/consultar-comprovante`,
  urlConsultarComprovante: (receiptCode: string) => `/cc/${receiptCode}`,
  welcome: () => '/',
};

type PathsMap = typeof pathsMap;

export const getPath = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
) => {
  const pathCb: (...args: any[]) => string = pathsMap[route];

  return pathCb(...params);
};

export const pushRoute = <TRoute extends keyof PathsMap>(
  route: TRoute,
  ...params: Parameters<PathsMap[TRoute]>
): any => {
  return push(getPath(route, ...params));
};

export type Push = (
  path: Path,
  state?: LocationState
) => CallHistoryMethodAction<[Path, LocationState?]>;

export interface IRouterActions {
  push: Push;
}



// WEBPACK FOOTER //
// ./src/routes/helpers.ts